interface AboutIntroSectionTexts {
  h1?: string;
  p1?: string;
  p2?: string;
  p3?: string;
  strongName?: string;
}

export default function AboutIntroSection({ texts }: { texts?: AboutIntroSectionTexts }) {
  const h1 = texts?.h1 ?? "";
  const p1 = texts?.p1 ?? "";
  const p2 = texts?.p2 ?? "";
  const p3 = texts?.p3 ?? "";
  const strongName = texts?.strongName ?? "";

  const renderP1 = () => {
    if (strongName && p1.includes(strongName)) {
      const parts = p1.split(strongName);
      return (
        <>
          {parts[0]}
          <strong className="text-primary-600">{strongName}</strong>
          {parts[1]}
        </>
      );
    }
    return <>{p1}</>;
  };

  return (
    <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
          NetBasis International - linking people & business
        </h2>
        <h1 className="font-sans text-sm md:text-base font-semibold text-foreground-950 mb-4 leading-relaxed">
          {h1}
        </h1>
        <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <p>{renderP1()}</p>
          <p>{p2}</p>
          <p>{p3}</p>
        </div>
      </div>
    </section>
  );
}